module.exports = __webpack_public_path__ + "static/media/wechat.fe8b4d51.svg";